﻿(function () {
	'use strict';

	angular.module('nha.portal').service('config.repository', configRepo);

	configRepo.$inject = ['PortalRestangular', 'baseService'];

	function configRepo(portalRestangular, baseService) {
		/** create the repo */
		var repo = {
			endpoint: 'config',
			getSettings: getSettings,
			getEnvironments: getEnvironments,
			saveSetting: saveSetting,
			removeSetting: removeSetting,
			hasApplication: hasApplication
		};

		/** public methods */

		function getEnvironments() {
			return baseService.getList(repo.endpoint.concat('/environments'), null, false, false, portalRestangular);
		}

		function getSettings() {
			return baseService.getList(repo.endpoint.concat('/settings'), null, false, false, portalRestangular);
		}

		function saveSetting(setting) {
			return portalRestangular.all(repo.endpoint.concat('/settings/save')).customPOST(setting);
		}

		function removeSetting(settingID) {
			return portalRestangular.one(repo.endpoint.concat('/settings/remove'), settingID).remove();
		}

		function hasApplication(schoolID, settingKey) {
			return portalRestangular.all(this.endpoint + '/hasapplication?schoolID=' + schoolID + '&settingKey=' + settingKey).customGET().then(function (result) {
				return result;
			});
		}

		/** return the repo */
		return repo;
	}
}());